export default "__VITE_ASSET__$a2xKjW2__"